import { useState, useEffect } from 'react';

/**
 * 响应式断点 Hook
 * @param {string} query - CSS media query
 * @returns {boolean}
 */
export function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => {
    if (typeof window !== 'undefined') {
      return window.matchMedia(query).matches;
    }
    return false;
  });

  useEffect(() => {
    const media = window.matchMedia(query);
    const handler = (e) => setMatches(e.matches);
    media.addEventListener('change', handler);
    setMatches(media.matches);
    return () => media.removeEventListener('change', handler);
  }, [query]);

  return matches;
}

/** 是否为移动端（宽度 < 768px） */
export function useIsMobile() {
  return useMediaQuery('(max-width: 767px)');
}
